var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "url(#pattern0_3404_12)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3404_12",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3404_12",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3404_12",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEOUlEQVR4nO2dO2gUURSGr+83ojY2sbHxgSgopJIoxLhzNmT33mEEIZJkz3VEUcEiWAjGWInPiIWPws5CECxSRRtLqwgawUIsFCxE8BEFJWrkRjfObB5mdnZzZu6cH06VnXt3/++cc+/MzmaEYLFYLBaLxWKxWKyY2uvqzY7CKyBxCKT+AkqPUoYj8UwmoHqetxCkvuZI/YPadMgaBGO+I/EhtdGQVQgm86kNhqxCGOv5CWw7kBUIILGP2lSICkHhOWGLQOrnSctwyFIlgMRhatMhEOY95aU+mZlKoDYcJgGQKQhJBZAZCEkGkAkISQdgPYQ0ALAaQloAWAshTQCshJA2ANZBSCMAqyCkFYA1ENIMwAoIaQeQegg2AEg1BFsApBaCTQBSCcE2AKmDYCOAKBAEtagNhzoaMhMIglrUhkOdDfkfBEEtasNhFgyZDoKgFrXhYCFwBqAYwCh1ZnMFKHpzuQUpeoN5DVDJDuo1mHdB1KLOQOAKqLUJ+MbzvHllwE0dHYsdpT9QG52lFnS2cg5H6RvURmcFwK9c0V8/YQ7Xb6Q2OiMA8NHU8+BTarOtB5B3sWOaebpraRQDqDRJ4nCTd2R52aC87NraUuhsGDfM61gLCkcYQP0q4HZwXEfieZP14bmwnwHUCUDe1TvLY/b09MwFpV+D1IOhuYqoGEAdADgSXwkh5oy3Hxd3lf+W87o2Vfw7hHe8BtS8AvBURau59Q+O7g21JqWvMoAaAnAk/mz1/HXBLHeUfh+A8zJYHU7B3xJltxNVcXdXs67Y2S/1QGi8oi5MgOSWdgRf4yh8wgBqBcDV+0PmSrw7ERJeCkGSeJwB1AKAxI+trf7S8lhtbaUVjsKvk6wRb4MX6IrFA2tA4TduQbErAK8HM9ucCU/92tLuiiq4F6dXx65cK9YA128MjuV5J5bk84dXTRa53LFFoXllKc8A4gCQ+kUc8E1NPfNNa+IKqL4CukVM/b1cwS2oit4/Yi6uiWBLUXjakfrmtKHwaOiYIm5kANUtvv1BI1sKnQ3mhGwGbevLnvb2ZRVV8JgX4agAiqiqvtbv6n2hYyUeqtWOppoQ1Ir6hs1lhok7Gj0YYfG+Hzy22fNXTn7uwACmMBD7gga2Kn9DJIBSf2/xcHUFwDsMYKYmFvS2oHmO1L1Rzcu5pVJwjLw62MwAMhqCWtQGAAOgNwG4AuiNAKKg7kDcgqhFnYHAFUBvAnALojcCiIK6A3ELohZ1BgJXAL0JwC2I3gggCuoOZG4V/ExtAlCF1J+o/TdfiAyRG6FowlH6WRIq4HKGAVyg9l+Y28fT9BgrqFngiPkySSRB1d4yDikOU/kiKdru+wtA6QfUpsBshdQD5jOLJGkMwthD3ar/IR0kPnDEZH7izK9cE8zt5GaHkLRnjEFV2Y7Dfz6LvmhuBKP2l8VisVgsFovFYonU6zes1FuafrSSagAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrades);
export default __webpack_public_path__ + "static/media/grades.e6e64a53136dd7bd0b2c231034b3083c.svg";
export { ForwardRef as ReactComponent };